import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { FC } from "react"

import { useProductInventoryContext } from "../../contexts"
import { useProductInventoryLotList } from "../../hooks"

import { ProductInventoryLotsTable } from "./ProductInventoryLotsTable"

import { PermissionActionType } from "@/constants/permissions"
import type { InventoryByLotItem } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

export const ProductInventoryLotsTab: FC = () => {
  const { productId } = useParams({ from: "/app/inventory/products/$productId/_layout/lots" })
  const { product } = useProductInventoryContext()
  const notify = useNotificationsStore((state) => state.enqueueNotification)

  const { hasPermissions } = usePermissionManager()
  const canMaintain = hasPermissions([PermissionActionType.INVENTORY_MAINTENANCE])

  const { inventories, isFetching, error, sorting, tableContainerRef, handleSortingChange, handleScroll } =
    useProductInventoryLotList({ productId: Number(productId) })

  const handleTransfer = (_inventory: InventoryByLotItem) => {
    notify({ type: NotificationType.Warning, message: "Not implemented yet" })
  }

  const handleCoaView = (_inventory: InventoryByLotItem) => {
    notify({ type: NotificationType.Warning, message: "Not implemented yet" })
  }

  return (
    <Box className='flex min-h-0 flex-1 overflow-y-auto'>
      <ProductInventoryLotsTable
        product={product}
        data={inventories}
        loading={isFetching}
        error={error}
        sorting={sorting}
        containerRef={tableContainerRef}
        canMaintain={canMaintain}
        onSortingChange={handleSortingChange}
        onScroll={handleScroll}
        onTransfer={handleTransfer}
        onCoaView={handleCoaView}
      />
    </Box>
  )
}
